import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

import { updateVisitorApiUrlsAtom } from '@/atoms/visitor';
import { MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { accountService } from '@/services/account.service';
import { useLicSettings } from './use-lic-settings';

export const useSyncApiUrls = (isBefore: boolean) => {
	const queryClient = useQueryClient();
	const updateVisitorApiUrls = useSetAtom(updateVisitorApiUrlsAtom);
	const { data } = useLicSettings();

	useEffect(() => {
		if (!data?.urls) {
			return;
		}
	
		const { apiBackend, oddsServer } = data.urls;
	
		MaybeMatch(isBefore).fold(
			() => {
				if (apiBackend) {
					accountService.updateAccountInfo(queryClient, { ApiBackendUrl: apiBackend });
				}
				if (oddsServer) {
					accountService.updateAccountInfo(queryClient, { OddsServerUrl: oddsServer });
				}
			},
			() => {
				if (apiBackend) {
					updateVisitorApiUrls({ ApiBackendUrl: apiBackend });
				}
				if (oddsServer) {
					updateVisitorApiUrls({ OddsServerUrl: oddsServer });
				}
			}
		);
	}, [data, isBefore, queryClient, updateVisitorApiUrls]);
};